import { __generator } from "tslib";
import { call } from 'redux-saga/effects';
import { request } from '../../xhr';
export function fetchGroupFolders(groupId, folderType) {
    var params, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                params = {
                    groupid: groupId,
                    type: folderType,
                };
                return [4 /*yield*/, call(request, {
                        method: 'get',
                        url: 'deviation/group_folders',
                        params: params,
                    }, function () {
                        if (process.env.NODE_ENV !== 'production') {
                            var collections = 
                            // eslint-disable-next-line global-require
                            require('@wix/da-sample-data').collections;
                            return {
                                results: collections,
                            };
                        }
                        return {
                            results: [],
                        };
                    })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}
export function addDeviationToGroupFolder(groupFolderId, deviationId) {
    var data, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                data = {
                    groupid: groupFolderId.groupId,
                    type: groupFolderId.type,
                    folderid: groupFolderId.folderId,
                    deviationid: deviationId,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'deviation/group_add',
                        data: data,
                    }, function () {
                        return { success: true };
                    }) || { success: false }];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}
//# sourceMappingURL=xhr.js.map